import GridSpinner from 'components/UI/GridSpinner'
import { Button, Container, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import { useCancelToken } from 'utils/hooks/useCancelToken'
import { useGetAccountAction } from 'modules/Services/hooks/useGetAccountAction'
import Campaign from './Campaign'
import styles from 'modules/Services/Campaigns/Main/subcomponents/List/campaign-list.module.scss'
import {
  CAMPAIGNS_CLEAN,
  YANDEX_SUBSCRIPTION_CAMPAIGN_DELETE,
  YANDEX_SUBSCRIPTION_CAMPAIGNS_FETCH,
} from 'modules/Services/types'

const CampaignsList = ({ networkType, accountId }) => {
  const pathGen = useGeneratePathI18n()
  const { cancelableDispatch } = useCancelToken()
  const createLink = useGetAccountAction('campaign-create')
  const { t } = useTranslation(['services'])
  const dispatch = useDispatch()

  const { i18n, loading, campaigns } = useSelector((state) => ({
    i18n: state['app'].i18n,
    loading: state['services/campaigns'].loading,
    campaigns: state['services/campaigns'].campaigns,
  }))

  useEffect(() => {
    dispatch({ type: CAMPAIGNS_CLEAN })

    cancelableDispatch({
      type: YANDEX_SUBSCRIPTION_CAMPAIGNS_FETCH,
      payload: {
        networkType,
        accountId,
      },
    })
  }, [])

  const deleteCampaign = useCallback((campaignId) => {
    dispatch({
      type: YANDEX_SUBSCRIPTION_CAMPAIGN_DELETE,
      payload: {
        networkType,
        accountId,
        campaignId,
      },
    })
  }, [])

  return (
    <div>
      {loading && (
        <div className={styles['campaigns__spinner-container']}>
          <GridSpinner width={32} style={{ height: '100%' }} />
        </div>
      )}
      {!loading && campaigns.length === 0 ? (
        <Container
          display={'flex'}
          flexJustify={'center'}
          flexAlign={'flex-end'}
          className={styles['campaigns__empty-row']}
        >
          <Typography variant="Body-20" color={'Label-Secondary'} noMargin>
            {t('services::campaigns_list.empty_list_label')}
          </Typography>
        </Container>
      ) : (
        campaigns.map((campaign) => (
          <div key={'campaign-' + campaign.id} className={styles['campaign-item']}>
            <Campaign
              {...campaign}
              accountId={accountId}
              key={'campaign-row-' + campaign.id}
              onDeleteCampaign={deleteCampaign}
            />
          </div>
        ))
      )}

      {!loading && (
        <Container
          display={'flex'}
          flexAlign={'center'}
          flexJustify={'center'}
          className={styles['add-campaign__container']}
        >
          <Button
            startIcon={<Icon name={createLink.icon} />}
            component={Link}
            to={pathGen(createLink.url, {
              i18n,
              networkType,
              accountId,
            })}
            variant={'primary'}
            size={'m'}
            className={styles['add-campaign__button']}
          >
            {t('services::campaigns_list.add_new_campaign')}
          </Button>
        </Container>
      )}
    </div>
  )
}

CampaignsList.propTypes = {
  networkType: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
}

export default CampaignsList
